"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = exports.newSession = void 0;
const dotenv = __importStar(require("dotenv"));
dotenv.config();
const buffer_1 = require("buffer");
const compiler_1 = require("./compiler");
const blockchain_state_1 = require("./blockchain-state");
const executor_1 = require("./executor");
const interfaces_1 = require("./interfaces");
const rpc_1 = require("./rpc");
const uint256_1 = require("./uint256");
const utils_1 = require("./utils");
function newSession(opts) {
    return new Session(opts);
}
exports.newSession = newSession;
class Session {
    constructor(opts) {
        this.opts = opts;
        this.state = (0, blockchain_state_1.newBlockchain)(this);
        this.rpc = new rpc_1.RPC(opts?.rpcUrl ?? process.env.RPC_URL, opts?.maxRpcCacheTime, opts?.cacheDir);
        if (opts?.contractsNames) {
            opts.contractsNames = Object.fromEntries(Object.entries(opts.contractsNames)
                .map(([k, v]) => [k.toLowerCase(), v]));
        }
    }
    addNames(names) {
        if (!names) {
            return this;
        }
        this.opts ?? (this.opts = {});
        this.opts.contractsNames = {
            ...this.opts.contractsNames,
            ...Object.fromEntries(Object.entries(names)
                .map(([k, v]) => [k.toLowerCase(), v])),
        };
        return this;
    }
    async deploy(code, opts, deployOpts) {
        const exec = new executor_1.Executor(await this.state.newTx({
            ...opts,
            contract: (0, utils_1.toAddress)('0x00'),
        }), (() => { }));
        const codeBuffer = toCode(code);
        const contractAddress = await exec.doCreate2((0, uint256_1.U256)(0), codeBuffer, deployOpts?.balance ?? (0, uint256_1.U256)(0));
        this.state = exec.state.popCallStack();
        return contractAddress;
    }
    deployRaw(code, opts, rawStorage) {
        const compiled = (0, compiler_1.compileCode)(toCode(code), opts?.name ?? (a => this.opts?.contractsNames?.[a]), opts?.forceId, opts?.knownSequences, this.opts?.cacheDir);
        this.state = this.state.setContract(compiled);
        if (rawStorage) {
            (0, blockchain_state_1.setStorageInstance)(this.state, compiled.contractAddress, rawStorage);
        }
        return compiled.contractAddress;
    }
    async prepareCall(input) {
        const code = await this.getContract(input.contract);
        const exec = new executor_1.Executor(await this.state.newTx(input), code);
        exec.onResult(ret => {
            if (!(0, interfaces_1.isFailure)(ret)) {
                this.state = ret.newState.popCallStack();
            }
        });
        return exec;
    }
    async prepareStaticCall(_contract, calldata, returndatasize) {
        if (typeof calldata === 'string') {
            calldata = (0, utils_1.parseBuffer)(calldata.startsWith('0x') ? calldata.substring(2) : calldata);
        }
        const contract = (0, utils_1.toAddress)(_contract);
        return this.prepareCall({
            contract,
            static: true,
            calldata,
            origin: (0, uint256_1.U256)(0),
            callvalue: (0, uint256_1.U256)(0),
            gasLimit: (0, utils_1.toUint)('ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'),
            gasPrice: (0, uint256_1.U256)(349834),
            retdatasize: returndatasize,
            timestamp: Date.now() / 1000,
        });
    }
    async getContract(_contract) {
        return await this.state.getContract(_contract);
    }
    contractKey(contract) {
        return (0, utils_1.to0xAddress)((0, utils_1.toAddress)(contract));
    }
}
exports.Session = Session;
function toCode(code) {
    if (typeof code === 'string') {
        return buffer_1.Buffer.from(code, 'hex');
    }
    if (code instanceof buffer_1.Buffer) {
        return code.subarray();
    }
    return code;
}
//# sourceMappingURL=session.js.map